module.exports = __webpack_public_path__ + "img/876-28bf8f.png";